
import React from 'react';
import { Navigate } from 'react-router-dom';

const ProtectedRoute = ({ children }) => {
    const token = localStorage.getItem('token');
    const userString = localStorage.getItem('user');
    const user = userString ? JSON.parse(userString) : null;

    if (!token || !user || user.role !== 'Admin') {
        // Redirect to login if not authenticated or not an admin
        return <Navigate to="/login" replace />;
    }

    return children;
};

export default ProtectedRoute;
